<template>
  <router-link
    class="list-row-container"
    :class="{ unread: !progressReport.readAt }"
    :to="reportRoute"
  >
    <span
      class="report-details text-sm"
      data-test="progress-report-details"
    >
      <span class="font-medium" data-test="progress-report-title">{{ progressReport.title }}</span>
      <span class="font-regular" data-test="progress-report-generated-at">{{ generatedAtLabel }}</span>
    </span>
  </router-link>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { format } from 'date-fns';
import type { ProgressReport } from '@/types/models';

const props = defineProps<{ progressReport: ProgressReport }>();

const generatedAtLabel = computed(() => {
  const generatedAt = new Date(props.progressReport.generatedAt);
  return Number.isNaN(generatedAt.getTime()) ? '' : format(generatedAt, 'MM/dd/yy');
});

const reportRoute = computed(() => ({
  name: 'progressReports#show',
  params: { uuid: props.progressReport.id },
}));
</script>

<style scoped lang="scss">
.list-row-container.unread:not(:hover) {
  background: var(--bg-brand-primary);
}

.report-details {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: left;
}
</style>
